import { render, staticRenderFns } from "./top1.vue?vue&type=template&id=5dcaba47"
import script from "./top1.vue?vue&type=script&lang=js"
export * from "./top1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports